import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react"

import "swiper/css/effect-fade"
import 'swiper/css';

import { P, H2, Sub } from "components/Typography"

import Video from "./Video"

export const GenericVideoBlock = ({
	title, text, altTitle, video, contentImage
}) => {

	return (
		<div>
			{text && <div style={{ padding: "2rem", backgroundColor: "#08041B" }}>
				{title && <H2 style={{ marginBottom: "0.5rem", fontSize: "1.6rem" }} color="white" >{altTitle || title}</H2>}
				<P style={{ marginBottom: 0 }}>{text}</P>
			</div>}
			<VideoContainer>
				{video && <Video {...video} />}
				{contentImage && <img alt="" style={{ width: "100%" }} loading="lazy" src={contentImage.url} />}
			</VideoContainer>
		</div>
	)
}

const Button = ({
	title, image, type, selected, i, select, name
}) => {
	return (
		<ButtonContainer className={`${selected === i ? "active" : "not"}`}>
			<StyledButton onClick={() => {
				select(i)
			}} className={`${type} ${selected === i ? "active" : "not"}`}>
				{image && <img alt={title} src={image.url} />}
				<Sub className="sub">{title || name}</Sub>
			</StyledButton>
			<div className="selected-state" />
		</ButtonContainer>
	)
}

const Carousel = ({
	items, type, content
}) => {
	const [index, setIndex] = useState(0)
	const [swiper, setSwiper] = useState(null)

	useEffect(() => {
		if (swiper) {
			swiper.slideTo(index)
		}
	}, [index, swiper])

	useEffect(() => {
		if (swiper) {
			// swiper.resize()
			setTimeout(() => {
				swiper.updateAutoHeight(10)
			}, 1000)
		}
	}, [swiper])

	return (
		<Section>
			<StyledNav>
				{items.map((item, i) => <Button select={setIndex} type={type} i={i} selected={index} set {...item} key={i} />)}
			</StyledNav>

			<Swiper
				style={{
					borderTop: " 1px solid var(--darkBorder)"
				}}
				className="how-to-play-carousel"
				modules={[EffectFade]}
				autoHeight
				speed={600}
				effect="fade"
				allowTouchMove={false}
				onSwiper={(swiper) => setSwiper(swiper)}
				fadeEffect={{
					crossFade: true // enables slides to cross fade
				}}
			>
				{content?.map((item, i) => <SwiperSlide key={i}>
					{item}
				</SwiperSlide>
				)}
			</Swiper>
		</Section>
	)
}

export default Carousel

const Section = styled.section`
	width: 100%;
`

const StyledNav = styled.nav`
	width: 100%;
	display: flex;
	position: relative;
	padding-left: 2rem;
	padding-top: 0.5rem;
	margin-top: -1rem;
	margin-bottom: -7px;
	overflow-x: auto;
	z-index: 20;

	&::scrollbar {
		opacity: 0;
	}

    justify-content: flex-start;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
`

const ButtonContainer = styled.div`
scroll-snap-align: center;
scroll-snap-stop: normal;
flex-shrink: 0;
position: relative;
	position: relative;
	padding-bottom: 1.5rem;

	.selected-state {
		position: absolute;
		bottom: -0px;
		left: 45%;transform: translateX(-50%);
		content: " ";
		width: 100px;
		height: 64.5px;
		background-size: 100%;
		z-index: 1;
		pointer-events: none;
		background-image: url("/images/how-to-play/Arrow.png");
		background-position: top;
		opacity: 0;
		transition: 0.3s ease-out opacity;
	}

	&.active .selected-state {opacity: 1}


	@media (max-width: 750px) {
		padding-bottom: 2.5rem;
		
		.selected-state {
		}
	}
`

const StyledButton = styled.button`

	overflow: visible;
	z-index: 5;

	&.enchants {
		width: 45px;
		margin-right: 0.5rem;
		opacity: 0.5;
		transition: 0.3s ease-out opacity, 0.3s ease-out background;

		img {
			width: 100%;
			border-radius: 50%;
			overflow: hidden;
			border: 1px solid var(--lilac)
		}

		&.active {
			opacity: 1;
		}

		.sub {display: none}
	}

	&.gameplay {
		padding: 0.5rem 0.5rem;
		padding-bottom: 0.6rem;
		margin-right: 10px;
		margin-bottom: 1rem;
		border: 1px solid var(--lightBorder);
		border-radius: 2px;
		opacity: 0.7;
		transition: 0.3s ease-out opacity, 0.3s ease-out background;

		p {
			line-height:1;
		}

		&.active {
			background: #40306B;
			opacity: 1;
		}
	}

	&.effects {
		width: 80px;
		margin-right: 0.5rem;
		opacity: 0.5;
		transition: 0.3s ease-out opacity, 0.3s ease-out background;

		@media (max-width: 750px) {
			width: 60px;
		}

		img {
			width: 100%;
			overflow: hidden;
		}

		&.active {
			opacity: 1;
		}

		.sub {text-transform: capitalize}
	}

`

const VideoContainer = styled.div`
padding: 8px;
background-color: #0C061E;
`